var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-m-allocations"},_vm._l((_vm.context),function(c){return _c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("M"+_vm._s(c.project_milestone.m_ident))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }